import { normalize } from 'normalizr';

import { callApi, pageToOffsetParams } from 'utils/api';
import * as schemas from 'schemas';

export function chatResourcesFetch(page) {
  return callApi('/chat/resources', {
    query: {
      ...pageToOffsetParams(page, process.env.KOOTH_PAGE_SIZE)
    }
  })
  .then(json => {
    const { resources, meta }  = json;
    const { result, entities } = normalize(resources, schemas.chatResourcesArraySchema);

    return {chatResourcesIds: result, entities, meta};
  });
}

export function chatScheduleFetch() {
  return callApi('/chat/schedule');
}

export function chatQuestionnaireSubmit(chatQuestionnaire) {
  return callApi('/questionnaires', {
    method: 'POST',
    body: chatQuestionnaire
  });
}

export function chatStatusFetch() {
  return callApi('/chat/status');
}




/** WEBPACK FOOTER **
 ** ./src/members/state/chat/api.js
 **/